import { gql, TypedDocumentNode } from "@apollo/client";

export type SummarizeInteractionNoteImageResponse = {
  summarizeInteractionNoteImage: {
    success: boolean;
    message: string | null;
    summary: string | null;
  };
};

export type SummarizeInteractionNoteImageVariables = {
  file: File;
};

export const SUMMARIZE_INTERACTION_NOTE_IMAGE_MUTATION: TypedDocumentNode<
  SummarizeInteractionNoteImageResponse,
  SummarizeInteractionNoteImageVariables
> = gql`
  mutation SummarizeInteractionNoteImage($file: Upload!) {
    summarizeInteractionNoteImage(file: $file) {
      success
      message
      summary
    }
  }
`;
